// 表示の拡大（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { $ } from './util.js';
import { scheduleBox } from './partbox.js';

// 見えている範囲（s 倍、左上が x・y の割合）
export interface View { s: number; x: number; y: number }

// ---- 表示の拡大 ----
// 見えている範囲 = キャラの四角の中の [x, x + 1/s] × [y, y + 1/s]（割合）。s は 1（全身）〜 VIEW_MAX
// 拡大はピンチ（スマホ）とホイール（PC）だけ。拡大しているときだけ左上に「全身」を出す（ダブルタップでも全身に）。
//   本物の CHOCO は決まった段（ZOOM_POS: 全身 → 顔 → からだ → あし）を順に回す作りで、使いにくいので変えた（ユーザー判断 2026-10-11）。
//   「選んでいるパーツに寄る」ボタンも作ったが、ピンチ・ホイールだけでよいことになった（同日）
// なめらかに動かすため、指やホイールで動かしている間だけ .view を合成レイヤー（will-change: transform）にして GPU に拡大縮小させ、
// 終わったら外してその倍率でくっきり描き直す。CSS の transition で拡大を動かすと、細かい SVG を拡大後の大きさで描き直すのが間に合わずカクついた
export const VIEW_MAX = 5;
export function clampView(v: View) {
  v.s = Math.max(1, Math.min(VIEW_MAX, v.s));
  const span = 1 / v.s;
  v.x = Math.max(0, Math.min(1 - span, v.x));
  v.y = Math.max(0, Math.min(1 - span, v.y));
  return v;
}
// 動かし始め（今の見え方のまま合成レイヤーにしてから動かす）・動かし終わり（delay ms 後に外して描き直す）
export function beginGesture() {
  clearTimeout(S.gestureTimer);
  const el = $('view');
  if (!el.classList.contains('gesturing')) { el.classList.add('gesturing'); void el.offsetWidth; }
}
export function endGesture(delay?: number) {
  clearTimeout(S.gestureTimer);
  S.gestureTimer = setTimeout(() => { $('view').classList.remove('gesturing'); }, delay || 0);
}
export function setViewTo(v: View) {
  scheduleBox();
  S.view = clampView(v);
  const zoomed = S.view.s > 1.001;
  $('view').style.transform = zoomed ? 'scale(' + S.view.s + ') translate(' + (-S.view.x * 100) + '%, ' + (-S.view.y * 100) + '%)' : '';
  $('btnView').hidden = !zoomed;
  $('stage').classList.toggle('zoomed', zoomed);
}
export function resetView() { setViewTo({ s: 1, x: 0, y: 0 }); }
